module.exports = __webpack_public_path__ + "img/guard-space.b2ad4c66.png";